import {
  ActionTypeEnum,
  AssetGroupCreateOptions,
  AssetGroupUpdateOptions,
  AssetMachinesCreateOptions,
  CreateAssetBody,
  UpdateAssetBody
} from 'app/models/api/asset-tree';
import { AssetNodeCategoryType } from '@festo-ax/smartenance-shared-ui';

export class AssetHierarchyUtils {
  static createAssetGroupCreateBody(options: AssetGroupCreateOptions): CreateAssetBody {
    return {
      actionType: ActionTypeEnum.CREATE,
      children: [{
        nodeDescription: options.nodeDescription,
        nodeCategory: AssetNodeCategoryType.ASSET_GROUP,
      }],
      ...(options?.parentNodeId && { parentNodeId: options.parentNodeId }),
    };
  }

  static createAssetGroupUpdateBody(options: AssetGroupUpdateOptions): UpdateAssetBody {
    return {
      actionType: ActionTypeEnum.UPDATE,
      nodeId: options.nodeId,
      nodeDescription: options.nodeDescription,
    };
  }

  static createAssetMachinesCreateBody(options: AssetMachinesCreateOptions): CreateAssetBody {
    return {
      actionType: ActionTypeEnum.CREATE,
      children: options.assetsIds.map(assetId => ({ assetId, nodeCategory: AssetNodeCategoryType.COMPONENT })),
      ...(options?.parentNodeId && { parentNodeId: options.parentNodeId }),
    };
  }
}
